import { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useAudio } from '../AudioContext'
import './PlayerBar.css'

const API_URL = 'https://radio.stellarfm.fr/api/nowplaying/stellarfm'

const PlayIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M8 5v14l11-7z" />
  </svg>
)
const PauseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
  </svg>
)
const VolumeHighIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0014 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
  </svg>
)
const VolumeLowIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z" />
  </svg>
)
const VolumeMuteIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16.5 12A4.5 4.5 0 0014 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z" />
  </svg>
)
const ShareIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z" />
  </svg>
)
const FacebookIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
)
const XIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.847L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
)
const WhatsAppIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
)
const CopyIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
  </svg>
)

const fmt = s => {
  const m = Math.floor(s / 60)
  const sec = Math.floor(s % 60)
  return `${m}:${sec.toString().padStart(2, '0')}`
}

export default function PlayerBar() {
  const location = useLocation()
  const { isPlaying, toggle, volume, setVolume, isMuted, toggleMute } = useAudio()
  const [nowPlaying, setNowPlaying] = useState(null)
  const [elapsed, setElapsed] = useState(0)
  const [duration, setDuration] = useState(0)
  const [showShare, setShowShare] = useState(false)
  const [copied, setCopied] = useState(false)
  const shareRef = useRef(null)

  useEffect(() => {
    const load = () =>
      fetch(API_URL)
        .then(r => r.json())
        .then(d => {
          setNowPlaying(d?.now_playing?.song || null)
          setElapsed(d?.now_playing?.elapsed ?? 0)
          setDuration(d?.now_playing?.duration ?? d?.now_playing?.song?.length ?? 0)
        })
        .catch(() => { })
    load()
    const iv = setInterval(load, 15000)
    return () => clearInterval(iv)
  }, [])

  // Tick elapsed every second (station progress, always running)
  useEffect(() => {
    const tick = setInterval(() => setElapsed(e => e + 1), 1000)
    return () => clearInterval(tick)
  }, [])

  // Close share dropdown on outside click
  useEffect(() => {
    const handle = e => {
      if (shareRef.current && !shareRef.current.contains(e.target)) setShowShare(false)
    }
    document.addEventListener('mousedown', handle)
    return () => document.removeEventListener('mousedown', handle)
  }, [])

  if (location.pathname === '/radio') return null

  const displayElapsed = duration ? Math.min(elapsed, duration) : elapsed
  const progress = duration ? (displayElapsed / duration) * 100 : 0
  const shareUrl = `${window.location.origin}/radio`
  const shareText = nowPlaying
    ? `J'écoute "${nowPlaying.title}" de ${nowPlaying.artist} sur StellarFM !`
    : 'Écoute StellarFM en direct !'

  const copyLink = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  const VolumeIconEl = (isMuted || volume === 0) ? VolumeMuteIcon
    : volume < 0.5 ? VolumeLowIcon
      : VolumeHighIcon

  return (
    <div className="player-bar">

      {/* Left: art + info */}
      <div className="player-bar__left">
        <div className="player-bar__art">
          {nowPlaying?.art
            ? <img src={nowPlaying.art} alt={nowPlaying.title} loading="lazy" decoding="async" />
            : <span className="player-bar__art-placeholder">♪</span>
          }
        </div>
        <div className="player-bar__info">
          <span className="player-bar__title">{nowPlaying?.title ?? '—'}</span>
          <span className="player-bar__artist">{nowPlaying?.artist ?? '—'}</span>
        </div>
      </div>

      {/* Center: play + progress stacked */}
      <div className="player-bar__center">
        <button className="player-bar__play-btn" onClick={toggle} aria-label={isPlaying ? "Mettre en pause" : "Lancer la lecture"}>
          {isPlaying ? <PauseIcon /> : <PlayIcon />}
        </button>
        <div className="player-bar__progress">
          <span className="player-bar__time">{fmt(displayElapsed)}</span>
          <div className="player-bar__bar">
            <div className="player-bar__bar-fill" style={{ transform: `scaleX(${progress / 100})` }} />
          </div>
          <span className="player-bar__time">{fmt(duration)}</span>
        </div>
      </div>

      {/* Right: volume + share */}
      <div className="player-bar__right">

        {/* Volume */}
        <div className="player-bar__vol-wrap">
          <button className="player-bar__icon-btn" onClick={toggleMute} title="Volume" aria-label={isMuted ? "Rétablir le son" : "Couper le son"}>
            <VolumeIconEl />
          </button>
          <div className="player-bar__vol-panel">
            <input
              type="range"
              min="0"
              max="1"
              step="0.02"
              value={isMuted ? 0 : volume}
              onChange={e => setVolume(parseFloat(e.target.value))}
              className="player-bar__vol-range"
              aria-label="Contrôle du volume"
            />
          </div>
        </div>

        {/* Share */}
        <div className="player-bar__share-wrap" ref={shareRef}>
          <button
            className={`player-bar__icon-btn${showShare ? ' player-bar__icon-btn--on' : ''}`}
            onClick={() => setShowShare(v => !v)}
            title="Partager"
            aria-label="Partager ce morceau"
          >
            <ShareIcon />
          </button>
          {showShare && (
            <div className="player-bar__share-menu">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
                target="_blank" rel="noopener noreferrer"
                className="player-bar__share-item"
              >
                <FacebookIcon /> Facebook
              </a>
              <a
                href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`}
                target="_blank" rel="noopener noreferrer"
                className="player-bar__share-item"
              >
                <XIcon /> X (Twitter)
              </a>
              <a
                href={`https://wa.me/?text=${encodeURIComponent(shareText + ' ' + shareUrl)}`}
                target="_blank" rel="noopener noreferrer"
                className="player-bar__share-item"
              >
                <WhatsAppIcon /> WhatsApp
              </a>
              <button className="player-bar__share-item" onClick={copyLink}>
                <CopyIcon /> {copied ? 'Copié !' : 'Copier le lien'}
              </button>
            </div>
          )}
        </div>

      </div>
    </div>
  )
}
